module.exports = __webpack_public_path__ + "static/media/student-finding-a-career.cf3e1888.jpg";